import { BaseText, ListItem } from 'aimo-ui';
import Icon from 'components/icons/Icon';
import { ExternalPaymentWrapper } from 'hooks/useExternalPaymentMethods';
import { noop } from 'lodash';
import React, { useCallback } from 'react';
import { StyledWrapper } from 'styles/ContainerStyles';
import { getExternalPaymentLogo } from 'utils/paymentUtils';
import ExternalPaymentInfoButton from './ExternalPaymentInfoButton';
import { TitleWrapper } from './PaymentMethodItem';

const TitleComponent: React.FC<{
  item: ExternalPaymentWrapper;
  indexValue: number;
}> = ({ item, indexValue }) => (
  <TitleWrapper>
    <StyledWrapper mb={0} maxWidth={230}>
      <BaseText testID={`credit-card-title-${indexValue}`} numberOfLines={1}>
        {item?.name}
      </BaseText>
    </StyledWrapper>
  </TitleWrapper>
);
const ExternalPaymentItem = ({
  item,
  indexValue,
}: {
  item: ExternalPaymentWrapper;
  indexValue: number;
}) => {
  const IconComponent = useCallback(
    () => (
      <Icon size="l" name={getExternalPaymentLogo(item.externalPaymentType)} />
    ),
    [item]
  );

  return (
    <ListItem
      item={item}
      indexValue={indexValue}
      onPress={noop}
      iconComponent={IconComponent}
      titleComponent={TitleComponent}
      rightContentComponent={ExternalPaymentInfoButton}
    />
  );
};

export default ExternalPaymentItem;
